import DocumentService from 'aurora-composition/services/documentService';
import PMAService from 'aurora-composition/services/pMAService';
import history from 'aurora-utils/history';
import WorkflowService from 'aurora-composition/services/workflowService';
import PropertiesService from 'aurora-composition/services/propertyService';
import isEmpty from 'lodash/isEmpty';

import addDays from 'date-fns/addDays';
import {
  CleverTapGenericServiceUploadDocumentEvent,
  CleverTapPMASelectPropertySelectionEvent,
  CleverTapPMAFetchSecondPartyEvent,
  CleverTapServicesPreValidation,
  CleverTapServicesStartApplication,
  CleverTapTaskReviewStatusViewEvent,
  CleverTapTaskReviewApplicationAcceptEvent,
  CleverTapTaskReviewApplicationTerminateEvent,
  CleverTapTaskReviewApplicationAcceptSuccessEvent,
  CleverTapTaskReviewApplicationTerminateSuccessEvent,
  CleverTapTaskReviewApplicationAcceptFailureEvent,
  CleverTapTaskReviewApplicationReturnFailureEvent,
} from 'aurora-utils/cleverTap.eventhelper';
import formatPreValidationForClevertap from 'aurora-utils/clevertap.validation.formatter';
import { convertNumberFormat } from 'aurora-utils/utils';
import OwnerService from '../../services/ownerService';
import * as types from './constants';

const initiatePMA = async (pmaInitiate, dispatch) => {
  try {
    const initiatePMAResult = await PMAService.registerApplication(pmaInitiate);
    dispatch({ type: types.INITIATE_PMA_APPLICATION_SUCCESS });
    if (initiatePMAResult.success) {
      if (pmaInitiate.applicationType === 'PMA_REGISTRATION')
        history.push(`/app/services/pma-registration/${initiatePMAResult?.result?.id}`);
      else if (pmaInitiate.applicationType === 'PMA_RENEWAL')
        history.push(`/app/services/pma-renewal/${initiatePMAResult?.result?.id}`);
      else if (pmaInitiate.applicationType === 'PMA_AMENDMENT')
        history.push(`/app/services/pma-amendment/${initiatePMAResult?.result?.id}`);
      else if (pmaInitiate.applicationType === 'PMA_CANCELLATION')
        history.push(`/app/services/pma-termination/${initiatePMAResult?.result?.id}`);
    }
    return initiatePMAResult;
  } catch (err) {
    dispatch({ type: types.INITIATE_PMA_APPLICATION_ERROR, payload: err });
    return err;
  }
};
// contract Id
// Application Type
export const initiateApplication = pmaInitiate => async dispatch => {
  try {
    dispatch({ type: types.INITIATE_PMA_APPLICATION });
    const validationParams = {
      applicationType: pmaInitiate.applicationType,
      ...(pmaInitiate.contractId && {
        contractId: pmaInitiate.contractId,
      }),
      ...(pmaInitiate?.involvedParties && {
        involvedParties: pmaInitiate?.involvedParties,
      }),
      ...(pmaInitiate?.pmaType && {
        pmaType: pmaInitiate?.pmaType,
      }),
    };
    const validation = await WorkflowService.checkValidation(validationParams);
    if (!isEmpty(validation?.result)) {
      CleverTapServicesPreValidation({
        property_id: pmaInitiate.elmsPropertyId,
        application_type: pmaInitiate.applicationType,
        ...formatPreValidationForClevertap(validation?.result),
      });
      dispatch({ type: types.INITIATE_PMA_APPLICATION_SUCCESS });
      history.replace('/app/services/validations', {
        ...validation?.result,
        pmaInitiate,
      });
      // history.push({
      //   pathname: '/app/services/validations',
      //   state: {
      //     ...validation?.result,
      //     pmaInitiate,
      //   },
      // });
      return {};
    }

    CleverTapServicesPreValidation({
      property_id: pmaInitiate.elmsPropertyI,
      application_type: pmaInitiate.applicationType,
    });
    CleverTapServicesStartApplication({
      property_id: pmaInitiate.elmsPropertyI,
      application_type: pmaInitiate.applicationType,
    });
    return initiatePMA(pmaInitiate, dispatch);
  } catch (err) {
    dispatch({ type: types.INITIATE_PMA_APPLICATION_ERROR, payload: err });
    return err;
  }
};
export const initiatePMAWithoutValidation = pmaInitiate => async dispatch => {
  return initiatePMA(pmaInitiate, dispatch);
};

export const fetchPMAApplication = (id, callback = null) => async dispatch => {
  dispatch({ type: types.FETCH_PMA_APPLICATION });
  PMAService.fetchApplication(id)
    .then(result => {
      const application = { ...result.result, lessThanOneMonth: false };
      if (
        result.success &&
        result?.result?.applicationType === 'PMA_RENEWAL' &&
        result?.result?.applicationDetails?.applicationStatus === 'DRAFT'
      ) {
        application.agreement.newContStartDate = application.agreement.contStartDate;
        application.agreement.contStartDate = addDays(
          new Date(application?.finalAgreement?.contEndDate || application?.agreement.contEndDate),
          1,
        );
        application.agreement.newContEndDate = application.agreement.contEndDate;
        const endDate = application.agreement.contEndDate;
        application.agreement.newContEndDate = endDate;
        application.agreement.contEndDate = '';
      }

      if (
      result.success &&
      result?.result?.applicationType === 'PMA_REGISTRATION' &&
      result?.result?.applicationDetails?.applicationStatus === 'DRAFT'
    ) {
      application.agreement.contStartDate = application.agreement.contStartDate  || new Date();
      application.agreement.contEndDate= application.agreement.contEndDate || '';
    }
   

      if (result.success && result?.result?.applicationType === 'PMA_AMENDMENT') {
        application.lessThanOneMonth = result?.result?.lessThanOneMonth;
      }
      if (callback) {
        callback(application);
      }
      dispatch({ type: types.FETCH_PMA_APPLICATION_SUCCESS, payload: application });
    })
    .catch(err => {
      dispatch({ type: types.FETCH_PMA_APPLICATION_ERROR, payload: err });
    });
};

export const fetchPMACompanyDetails = (id, step) => async (dispatch, getState) => {
  const { application, properties } = getState().pmaReducer;
  await dispatch({ type: types.FETCH_PMA_COMPANY_DETAILS });
  const propertyArr = properties?.properties?.map(plot => plot.id);
  await OwnerService.fetchCompanyByLicense(id)
    .then(result => {
      CleverTapPMAFetchSecondPartyEvent({
        screenName: `screen_${application?.applicationDetails?.applicationType || ''}_${step}_view`,
        applicationStatus: application?.applicationDetails?.applicationStatus || '',
        applicationId: application?.applicationId || null,
        applicationNumber: application?.applicationDetails?.applicationNumber || null,
        isSuccess: true,
        applicationType: application?.applicationDetails?.applicationType,
        stepName: step,
        fetchID: id,
        propertyIds: convertNumberFormat(propertyArr),
      });
      dispatch({ type: types.FETCH_PMA_COMPANY_DETAILS_SUCCESS, payload: result.result });
    })
    .catch(err => {
      CleverTapPMAFetchSecondPartyEvent({
        screenName: `screen_${application?.applicationDetails?.applicationType || ''}_${step}_view`,
        applicationStatus: application?.applicationDetails?.applicationStatus || '',
        applicationId: application?.applicationId || null,
        applicationNumber: application?.applicationDetails?.applicationNumber || null,
        isSuccess: false,
        applicationType: application?.applicationDetails?.applicationType,
        stepName: step,
        fetchID: id,
        errorCode: err?.statusCode,
        errorMessage: err?.description || err?.message,
      });
      dispatch({ type: types.FETCH_PMA_COMPANY_DETAILS_ERROR, payload: err });
    });
};
export const savePMAApplication = id => async dispatch => {
  try {
    dispatch({ type: types.SAVE_PMA_APPLICATION });
    const result = await PMAService.savePMAApplication(id);
    dispatch({ type: types.SAVE_PMA_APPLICATION_SUCCESS, payload: result.result });
    return result;
  } catch (err) {
    dispatch({ type: types.SAVE_PMA_APPLICATION_ERROR, payload: err });
    return err;
  }
};

export const changeWorkflowStep = step => async dispatch => {
  dispatch({ type: types.CHANGE_PMA_STEP, payload: step });
};

export const uploadDocument = (body, params, details, stepName) => async dispatch => {
  try {
    dispatch({ type: types.UPLOAD_PMA_DOCUMENT });

    const document = await DocumentService.uploadDocument(body, params);

    if (!document?.success) throw new Error('unable_to_upload_the_document');

    CleverTapGenericServiceUploadDocumentEvent({
      screenName: `screen_${details?.applicationType}_${stepName}_view`,
      applicationStatus: details?.applicationStatus,
      applicationId: details?.applicationId,
      applicationNumber: details?.applicationNumber,
      applicationType: details?.applicationType,
      stepName,
      documentType: params.documentType,
    });
    dispatch({ type: types.UPLOAD_PMA_DOCUMENT_SUCCESS, payload: document?.result });
  } catch (error) {
    dispatch({ type: types.UPLOAD_PMA_DOCUMENT_ERROR, payload: error });
  }
};

export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_PMA_DOCUMENT });
    const params = { ...payload, header: true };
    const documentPdf = await DocumentService.downloadDocumentV2(params);

    const fileURL = 'data:' + documentPdf?.result?.fileExtension + ';base64,' + documentPdf?.result?.bytes;

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', documentPdf?.result?.fileName);

    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
    dispatch({ type: types.DOWNLOAD_PMA_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_PMA_DOCUMENT_ERROR, payload: error });
  }
};

export const deleteDocument = (fileId, query) => async dispatch => {
  try {
    dispatch({ type: types.DELETE_PMA_DOCUMENT });

    await DocumentService.deleteDocument(query);

    dispatch({ type: types.DELETE_PMA_DOCUMENT_SUCCESS, payload: { fileId } });
  } catch (error) {
    dispatch({ type: types.DELETE_PMA_DOCUMENT_ERROR, payload: error });
  }
};
export const getPMADocuments = applicationId => async dispatch => {
  try {
    dispatch({ type: types.GET_PMA_DOCUMENTS });
    const documents = await DocumentService.fetchApplicationDocuments({ applicationId });
    dispatch({ type: types.GET_PMA_DOCUMENTS_SUCCESS, payload: documents.result });
  } catch (error) {
    dispatch({ type: types.GET_PMA_DOCUMENTS_ERROR, payload: error });
  }
};

export const fetchPMAUserDetails = eidNumberOrUnified => async dispatch => {
  dispatch({ type: types.FETCH_PMA_USER_DETAILS });
  OwnerService.fetchUserById(eidNumberOrUnified)
    .then(result => {
      dispatch({ type: types.FETCH_PMA_USER_DETAILS_SUCCESS, payload: result.result });
    })
    .catch(err => {
      dispatch({ type: types.FETCH_PMA_USER_DETAILS_ERROR, payload: err });
    });
};
export const addPMAProperties = propertyObject => async (dispatch, getState) => {
  const { application } = getState().pmaReducer;

  try {
    dispatch({ type: types.ADD_PMA_PROPERTIES });
    const pmaValidation = await PMAService.validatePMAProperties({
      applicationId: propertyObject.applicationId,
      plotIds: propertyObject?.properties?.map(plot => plot.propertyID),
    });
    if (
      pmaValidation?.result?.validation?.crossValidations.length > 0 ||
      Object.keys(pmaValidation?.result?.validation?.propertyValidations).length > 0
    ) {
      const propertyArr = propertyObject?.properties?.map(plot => plot.plotID);
      CleverTapPMASelectPropertySelectionEvent({
        screenName: `screen_${application?.applicationDetails?.applicationType || ''}_SELECT_PROPERTY_view`,
        applicationStatus: application?.applicationDetails?.applicationStatus || '',
        applicationId: propertyObject?.applicationId || null,
        applicationNumber: application?.applicationDetails?.applicationNumber || null,
        propertyIds: convertNumberFormat(propertyArr),
        isSuccess: false,
        applicationType: application?.applicationDetails?.applicationType,
        stepName: 'SELECT_PROPERTY',
      });
      if (propertyObject?.isUnit === false) {
        dispatch({
          type: types.ADD_PMA_VALIDATION_ERROR,
          payload: { validation: pmaValidation?.result?.validation, data: propertyObject },
        });
        history.push({
          pathname: '/app/services/pma-validation',
          state: {
            validation: pmaValidation?.result?.validation,
            data: propertyObject,
          },
        });
        return;
      }
      if (propertyObject?.isUnit === true) {
        dispatch({
          type: types.ADD_PMA_UNIT_VALIDATION_ERROR,
          payload: { validation: pmaValidation?.result?.validation, data: propertyObject },
        });
        // eslint-disable-next-line consistent-return
        return false;
      }
    }
    const pmaAddProperty = await PMAService.addPMAProperties(
      {
        applicationId: propertyObject.applicationId,
        plotIds: propertyObject?.properties?.map(plot => plot.propertyID),
        // properties: propertyObject?.properties?.map((plot) => {
        //   return {
        //     districtId: plot.districtId,
        //     communityId: plot.communityId,
        //     municipalityId: plot.municipalityID,
        //     buildingRegNumber: plot.buildingRegNum,
        //     propertyType: plot.propertyType,
        //     plotId: plot.plotID,
        //     plotNumber: plot.plotNumber,
        //     unitNumber: plot.unitNumber,
        //     unitRegNumber: plot.unitRegNum,
        //     premiseId: plot.premiseId,
        //     premiseNumber: plot.premiseNumber,
        //     unitUsageEn: plot.unitUsageEn,
        //     unitUsageAr: plot.unitUsageAr,
        //     unitTypeEn: plot.unitTypeEn,
        //     unitTypeAr: plot.unitTypeAr,
        //     noOfRooms: plot.bedrooms,
        //     area: plot.areaSize,
        //     buildingPlotId: plot.buildingPlotId,
        //     buildingNameAr: plot.buildingNameAr,
        //     buildingNameEn: plot.buildingNameEn,
        //     buildingNumber: plot.buildingNumber,
        //     communityNameAr: plot.communityNameAr,
        //     communityNameEn: plot.communityNameEn,
        //     communityNumber: plot.communityNumber,
        //     districtNameAr: plot.districtNameAr,
        //     districtNameEn: plot.districtNameEn,
        //     districtNumber: plot.districtNumber,
        //     municipalityNameAr: plot.municipalityNameAr,
        //     municipalityNameEn: plot.municipalityNameEn,
        //     roadEn: plot.roadNameEn,
        //     roadAr: plot.roadNameAr,
        //     roadNumber: plot.roadNumber,
        //     plotAddress: plot.plotAddress,
        //     landUseNameEn: plot.landUseNameAr,
        //     landUseNameAr: plot.landUseNameEn,
        //     certificateNo: plot?.certificateNo,
        //     certificateType: plot?.certificateType,
        //   };
        // }),
      },
      propertyObject.isOverride,
    );
    if (pmaAddProperty.success) {
      dispatch({ type: types.ADD_PMA_PROPERTIES_SUCCESS, payload: pmaAddProperty.result });
      if (propertyObject?.isAmendment)
        !propertyObject?.isUnit && history.push('/app/services/pma-amendment/' + propertyObject.applicationId);
      else !propertyObject?.isUnit && history.push('/app/services/pma-registration/' + propertyObject.applicationId);
    }
    const propertyArr = propertyObject?.properties?.map(plot => plot.plotID);
    CleverTapPMASelectPropertySelectionEvent({
      screenName: `screen_${application?.applicationDetails?.applicationType || ''}_SELECT_PROPERTY_view`,
      applicationStatus: application?.applicationDetails?.applicationStatus || '',
      applicationId: propertyObject?.applicationId || null,
      applicationNumber: application?.applicationDetails?.applicationNumber || null,
      propertyIds: convertNumberFormat(propertyArr),
      isSuccess: true,
      applicationType: application?.applicationDetails?.applicationType,
      stepName: 'SELECT_PROPERTY',
    });
    // eslint-disable-next-line consistent-return
    return pmaAddProperty.success;
  } catch (err) {
    const propertyArr = propertyObject?.properties?.map(plot => plot.plotID);
    CleverTapPMASelectPropertySelectionEvent({
      screenName: `screen_${application?.applicationDetails?.applicationType || ''}_SELECT_PROPERTY_view`,
      applicationStatus: application?.applicationDetails?.applicationStatus || '',
      applicationId: propertyObject?.applicationId || null,
      applicationNumber: application?.applicationDetails?.applicationNumber || null,
      propertyIds: convertNumberFormat(propertyArr),
      isSuccess: false,
      applicationType: application?.applicationDetails?.applicationType,
      stepName: 'SELECT_PROPERTY',
      errorCode: err?.statusCode,
      errorMessage: err?.description || err?.message,
    });
    dispatch({ type: types.ADD_PMA_PROPERTIES_ERROR, payload: err });
    // eslint-disable-next-line consistent-return
    return false;
  }
};

export const removePMAProperties = propertyObject => async dispatch => {
  try {
    dispatch({ type: types.REMOVE_PMA_PROPERTIES });
    const pmaAddProperty = await PMAService.removePMAProperties(propertyObject);
    dispatch({ type: types.REMOVE_PMA_PROPERTIES_SUCCESS });
    return pmaAddProperty.success;
  } catch (err) {
    dispatch({ type: types.REMOVE_PMA_PROPERTIES_ERROR, payload: err });
    return false;
  }
};

export const getPMABuildings = (propertyObject, pageInfo) => async dispatch => {
  try {
    dispatch({ type: types.GET_PMA_BUILDINGS });
    const pmaAddProperty = await PMAService.getPMAProperties(propertyObject, pageInfo);
    dispatch({ type: types.GET_PMA_BUILDINGS_SUCCESS, payload: pmaAddProperty?.result });
  } catch (err) {
    dispatch({ type: types.GET_PMA_BUILDINGS_ERROR, payload: err });
  }
};
export const getPMAUnits = propertyObject => async dispatch => {
  try {
    dispatch({ type: types.GET_PMA_UNITS });
    const pmaAddProperty = await PMAService.getPMAUnits(propertyObject);
    dispatch({ type: types.GET_PMA_UNITS_SUCCESS, payload: pmaAddProperty?.result });
    return pmaAddProperty;
  } catch (err) {
    dispatch({ type: types.GET_PMA_UNITS_ERROR, payload: err });
    return err;
  }
};
// eslint-disable-next-line consistent-return
export const checkoutPMA = applicationId => async dispatch => {
  try {
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION });
    const pmaAddProperty = await PMAService.checkoutPMAApplication(applicationId);
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION_SUCCESS, payload: pmaAddProperty?.result });
    return pmaAddProperty;
  } catch (err) {
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION_ERROR, payload: err });
  }
};

// eslint-disable-next-line consistent-return
export const terminateCheckoutPMA = (applicationId, params) => async dispatch => {
  try {
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION });
    const pmaAddProperty = await PMAService.pmaCancellationInitiate(applicationId, params);
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION_SUCCESS, payload: pmaAddProperty?.result });
    return pmaAddProperty;
  } catch (err) {
    dispatch({ type: types.CHECKOUT_PMA_APPLICATION_ERROR, payload: err });
  }
};

export const downloadContractPmaApplication = (id, name = 'PMA Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_PMA_CONTRACT_DOCUMENT });
    const documentPdf = await PMAService.getApplicationPDFApp(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    const title = name?.defaultmessages || name;
    // window.open(fileURL);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_PMA_CONTRACT_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_PMA_CONTRACT_DOCUMENT_ERROR, payload: error });
  }
};

export const downloadApplicationContract = (id, name = 'PMA Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_PMA_APPLICATION_CONTRACT });
    const documentPdf = await PMAService.downloadApplicationContract(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    const title = name?.defaultmessages || name;
    // window.open(fileURL);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_PMA_APPLICATION_CONTRACT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_PMA_APPLICATION_CONTRACT_ERROR, payload: error });
  }
};

export const gotoSuccessScreen = data => {
  history.replace('/app/services/pma/application/success', data);
};

export const discardApplication = (id, params = { status: 'DISCARD' }, data) => async dispatch => {
  try {
    dispatch({ type: types.GET_PMA_CANCEL_APPLICATION });

    await WorkflowService.cancelApplication(id, params);
    dispatch({ type: types.GET_PMA_CANCEL_APPLICATION_SUCCESS });
    if (params?.status === 'CANCEL') {
      gotoSuccessScreen(data);
    } else {
      history.replace('/app/services?slug=lease');
    }
  } catch (error) {
    dispatch({ type: types.GET_PMA_CANCEL_APPLICATION_ERROR, payload: error });
  }
};

export const fetchPMALeaseableProperties = payload => async dispatch => {
  try {
    dispatch({ type: types.GET_PMA_CANCEL_APPLICATION });
    const response = PropertiesService.fetchLeaseProperties(payload);
    dispatch({ type: types.GET_PMA_UNITS_BY_BUILDING_SUCCESS });
    return response;
  } catch (err) {
    dispatch({ type: types.GET_PMA_UNITS_BY_BUILDING_ERROR, payload: err });
    return { success: false };
  }
};
export const fetchBreakdown = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_BREAKDOWN });
    const res = await PMAService.fetchBreakdown(id);

    return res;
  } catch (error) {
    dispatch({ type: types.FETCH_BREAKDOWN_ERROR, payload: { error } });
    return error;
  }
};

export const updatePMAType = value => dispatch => {
  dispatch({ type: types.UPDATE_PMA_TYPE, payload: value });
};

export const updateError = value => dispatch => {
  dispatch({ type: types.UPLOAD_PMA_DOCUMENT_ERROR, payload: value });
};

// bnan approval

export const bankApprovalAndReturn = payload => async dispatch => {
  try {
    dispatch({ type: types.BANK_APPROVAL });
    const newPayload = { ...payload };
    delete newPayload.applicationType;

    let resp = null;

    if (payload.applicationType === 'PMA_CANCELLATION') {
      resp = await PMAService.pmaTerminationApplicationBankApprovalAndReturn(newPayload);
    } else {
      resp = await PMAService.pmaApplicationBankApprovalAndReturn(newPayload);
    }

    dispatch({
      type: types.BANK_APPROVAL_SUCCESS,
    });

    return resp;
  } catch (error) {
    dispatch({ type: types.BANK_APPROVAL_ERROR, payload: error });
    return error;
  }
};
export const pmcSignatoryApprovalAndReturn = payload => async dispatch => {
  try {
    dispatch({ type: types.PMC_SIGNATORY_APPROVAL });
    const newPayload = { ...payload };
    delete newPayload.applicationType;

    let resp = null;

    if (payload.applicationType === 'PMA_CANCELLATION') {
      resp = await PMAService.pmaCancellationPartyApproval(newPayload);
    } else {
      resp = await PMAService.pmaApplicationActionParties(newPayload);
    }
    dispatch({
      type: types.PMC_SIGNATORY_APPROVAL_SUCCESS,
    });
    return resp;
  } catch (error) {
    dispatch({ type: types.PMC_SIGNATORY_APPROVAL_ERROR, payload: error });
    return error;
  }
};

export const approvalsFlow = (id, actionParams = null, status, data = {}) => async dispatch => {
  const cleverTapOwnerPayload = {};
  const { application = {} } = data;
  application?.owners?.forEach((owner, index) => {
    const currentIndex = index;
    cleverTapOwnerPayload['ownerUserId_' + currentIndex] = owner?.eidOrUnified;
    cleverTapOwnerPayload['ownerNameTradeLicenseNumber_' + currentIndex] = owner?.tradeLicenseNumber;
    cleverTapOwnerPayload['ownerNameEn_' + currentIndex] = owner?.ownerNameEn;
    cleverTapOwnerPayload['ownerNameAr_' + currentIndex] = owner?.ownerNameAr;
    cleverTapOwnerPayload['ownerNameEmail_' + currentIndex] = owner?.email;
    cleverTapOwnerPayload['ownerNamePhone_' + currentIndex] = owner?.phoneNumber;
    cleverTapOwnerPayload['ownerRejectionReason_' + currentIndex] = owner?.rejectionReason;
    cleverTapOwnerPayload['ownerPartyType_' + currentIndex] = owner?.partyType;
  });
  const cleverTapGenericPayload = {
    screenName: 'screen_task_details_view',
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationStep: status || '',
    progressStatus: application?.applicationDetails?.progressStatus,
    contractNumber: application?.contractNo,
    pmaTypeEn: application?.pmaTypeEn,
    pmaClassification: application?.pmaClassification,
    lastStep: application?.lastStep,
    contractDownload: application?.contractDownload,
    status: application?.status,
    pmaCompanyNameEn: application?.company?.nameEn,
    pmaCompanyNameAr: application?.company?.nameAr,
    pmaCompanyPhone: application?.company?.phone,
    pmaCompanyEmail: application?.company?.email,
    pmaCompanyRejectionReason: application?.company?.rejectionReason,
    contractStartDate: application?.agreement?.contStartDate,
    contractEndDate: application?.agreement?.contEndDate,
    amountType: application?.agreement?.amountType,
    totalAmount: application?.agreement?.totalAmount,
    allowFirstPartyAccess: application?.agreement?.allowFirstPartyAccess,
    rentCollectionBehalfOwner: application?.agreement?.rentCollectionBehalfOwner,
    cancelPmaWithoutBothConsent: application?.agreement?.cancelPmaWithoutBothConsent,
    pmaIndividualNameEn: application?.individual?.nameEn,
    pmaIndividualNameAr: application?.individual?.nameAr,
    pmaIndividualNamePhone: application?.individual?.phone,
    pmaIndividualNameEmail: application?.individual?.email,
    pmaIndividualNameRejectionReason: application?.individual?.rejectionReason,
    pmaIndividualNationality: application?.individual?.nationalityEn,
    ...cleverTapOwnerPayload,
  };
  try {
    dispatch({ type: types.PMA_APPLICATION_LOADING });

    if (actionParams != null) {
      // final owner
      CleverTapTaskReviewStatusViewEvent({
        applicationType: application?.applicationDetails?.applicationType,
        applicationStep: status || '',
      });

      if (actionParams.approval) {
        CleverTapTaskReviewApplicationAcceptEvent({ ...cleverTapGenericPayload });
      } else {
        CleverTapTaskReviewApplicationTerminateEvent({
          ...cleverTapGenericPayload,
        });
      }

      const req = {
        applicationId: id,
        approved: actionParams.approval,
        rejectionReason: actionParams.rejection,
      };

      switch (status) {
        case 'OWNER_APPROVAL':
          if (application?.applicationDetails?.applicationType === 'PMA_CANCELLATION') {
            await PMAService.pmaCancellationOwnerApproval(req);
          } else {
            await PMAService.pmaApplicationActionOtherOwner(req);
          }
          break;
        case 'PMA_APPROVAL':
          if (application?.applicationDetails?.applicationType === 'PMA_CANCELLATION') {
            await PMAService.pmaCancellationPartyApproval(req);
          } else {
            await PMAService.pmaApplicationActionParties(req);
          }
          break;
        default:
          return;
      }

      if (actionParams.approval) {
        CleverTapTaskReviewApplicationAcceptSuccessEvent({ ...cleverTapGenericPayload });
      } else {
        CleverTapTaskReviewApplicationTerminateSuccessEvent({
          ...cleverTapGenericPayload,
        });
      }

      dispatch({
        type: types.PMA_APPLICATION_SUCCESS,
      });
      gotoSuccessScreen(data);
    }
  } catch (e) {
    if (actionParams.approval) {
      CleverTapTaskReviewApplicationAcceptFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: e?.message,
        errorCode: e?.statusCode,
      });
    } else {
      CleverTapTaskReviewApplicationReturnFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: e?.message,
        errorCode: e?.statusCode,
      });
    }
    dispatch({
      type: types.PMA_APPLICATION_ERROR,
      payload: {
        error: e,
      },
    });
  }
};

export const rejectApplication = (id, params) => async dispatch => {
  try {
    dispatch({ type: types.REJECT_WITH_REASON });
    const resp = await PMAService.rejectApplication(id, params);
    dispatch({
      type: types.REJECT_WITH_REASON_SUCCESS,
    });
    return resp;
  } catch (error) {
    dispatch({ type: types.REJECT_WITH_REASON_ERROR, payload: error });
    return error;
  }
};

export const fetchPMAPaymentBreakdown = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_BREAKDOWN });
    const data = await PMAService.fetchBreakdown(id);
    dispatch({
      type: types.FETCH_BREAKDOWN_SUCCESS,
      payload: { breakdown: data?.result },
    });
    return data;
  } catch (error) {
    dispatch({ type: types.FETCH_BREAKDOWN_ERROR, payload: error });
    return error;
  }
};

export const resetErrorMeesage = () => async dispatch => {
  dispatch({ type: types.DOWNLOAD_PMA_DOCUMENT_SUCCESS });
};

export const resetError = () => async dispatch => {
  dispatch({ type: types.RESET_ERROR });
};

export const addError = err => async dispatch => {
  dispatch({ type: types.INITIATE_PMA_APPLICATION_ERROR, payload: err });
};
